import WinnerTeamInfo from "@/src/components/game/Leaderboard/WinnerTeamInfo";
import JamContainer from "@/src/components/ui/molecules/JamContainer/JamContainer";
import { LeaderboardTeam } from "@/src/types/JamLeaderboard";
import { i18nKeys } from "@/src/utils/i18n.utils";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const Winners: React.FC<{ sortedTeams: LeaderboardTeam[] }> = memo(({ sortedTeams }) => {
  const { t } = useTranslation();
  return (
    <div className="winner-container">
      <JamContainer>
        <div className="greetings">{t(i18nKeys.jamDashboard.leaderboard.greetings.title)}</div>
      </JamContainer>
      <div className="winners-trophy">
        <div className="winners-trophy-inner">
          <img src="/assets/Silver.png" className="silver" alt="silver-trophy-winner" />
          <img src="/assets/Gold.png" className="gold" alt="gold-trophy-winner" />
          <img src="/assets/Bronze.png" className="bronze" alt="bronze-trophy-winner" />
        </div>
      </div>
      <img src="/assets/Podium.png" className="podium-img" alt="podium" />
      <div className="winners-info">
        <WinnerTeamInfo team={sortedTeams[1]} index={1} />
        <WinnerTeamInfo team={sortedTeams[0]} index={0} />
        <WinnerTeamInfo team={sortedTeams[2]} index={2} />
      </div>
    </div>
  );
});

export default Winners;